import * as angular from "angular";
import { IGroupUserMapping, IUserDriverMapping, IUserGeofenceMapping, IUserVehicleMapping } from "@interfaces/IUser";



export class UserMappingsService {

    static $inject = ["$http"];

    constructor(
        private readonly $http: angular.IHttpService,
    ) {
    }

    getDriverMappings(invalidateCache = false): angular.IPromise<IUserDriverMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/driverMappings`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserDriverMapping[]>) => {
                return response.data;
            });
    }

    getDriverMappingsByUserId(userId:number,invalidateCache = false): angular.IPromise<IUserDriverMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/driverMappings/${userId}`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserDriverMapping[]>) => {
                return response.data;
            });
    }

    getVehicleMappings(invalidateCache = false): angular.IPromise<IUserVehicleMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/vehicleMappings`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserVehicleMapping[]>) => {
                return response.data;
            });
    }

    getVehicleMappingsByUserId(userId: number, invalidateCache = false): angular.IPromise<IUserVehicleMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/vehicleMappings/${userId}`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserVehicleMapping[]>) => {
                return response.data;
            });
    }

    getGeofenceMappings(invalidateCache = false): angular.IPromise<IUserGeofenceMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/geofenceMappings`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserGeofenceMapping[]>) => {
                return response.data;
            });
    }

    getGeofenceMappingsByUserId(userId: number, invalidateCache = false): angular.IPromise<IUserGeofenceMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/geofenceMappings/${userId}`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUserGeofenceMapping[]>) => {
                return response.data;
            });
    }

    getGroupMappings(invalidateCache = false): angular.IPromise<IGroupUserMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/groupMappings`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IGroupUserMapping[]>) => {
                return response.data;
            });
    }

    getGroupMappingsByUserId(userId: number, invalidateCache = false): angular.IPromise<IGroupUserMapping[]> {
        return this
            .$http({
                url: `/api/userMappings/groupMappings/${userId}`,
                method: "GET",
                params: { minsToLive: 60, invalidateCache: invalidateCache }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IGroupUserMapping[]>) => {
                return response.data;
            });
    }

    updateUserDriverMappings(userId: number,driverIds:number[]): angular.IPromise<void> {
        return this
            .$http({
                method: "POST",
                url: `/api/userMappings/driverMappings/${userId}`,
                data: driverIds
            })
            .then((response: angular.IHttpPromiseCallbackArg<void>) => {
                return;
            });
    }

    updateUserVehicleMappings(userId: number, vehicleIds: number[]): angular.IPromise<void> {
        return this
            .$http({
                method: "POST",
                url: `/api/userMappings/vehicleMappings/${userId}`,
                data: vehicleIds
            })
            .then((response: angular.IHttpPromiseCallbackArg<void>) => {
                return;
            });
    }

    updateUserGeofenceMappings(userId: number, geofenceIds: number[]): angular.IPromise<void> {
        return this
            .$http({
                method: "POST",
                url: `/api/userMappings/geofenceMappings/${userId}`,
                data: geofenceIds
            })
            .then((response: angular.IHttpPromiseCallbackArg<void>) => {
                return;
            });
    }

    updateUserGroupMappings(userId: number, groupIds: number[]): angular.IPromise<void> {
        return this
            .$http({
                method: "POST",
                url: `/api/userMappings/groupMappings/${userId}`,
                data: groupIds
            })
            .then((response: angular.IHttpPromiseCallbackArg<void>) => {
                return;
            });
    }
}
